import { jsxs, jsx } from "react/jsx-runtime";
const IconCheck = ({ className }) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      className,
      children: [
        /* @__PURE__ */ jsxs("g", { filter: "url(#filter0_d_3277_8971)", children: [
          /* @__PURE__ */ jsx(
            "mask",
            {
              id: "mask0_3277_8971",
              style: {
                maskType: "alpha"
              },
              maskUnits: "userSpaceOnUse",
              x: "0",
              y: "0",
              width: "18",
              height: "18",
              children: /* @__PURE__ */ jsx(
                "rect",
                {
                  width: "18",
                  height: "18",
                  fill: "#D9D9D9"
                }
              )
            }
          ),
          /* @__PURE__ */ jsx("g", { mask: "url(#mask0_3277_8971)", children: /* @__PURE__ */ jsx(
            "path",
            {
              d: "M7.16435 11.2102L13.44 4.93453C13.6108 4.76366 13.8112 4.67822 14.0411 4.67822C14.271 4.67822 14.4714 4.76366 14.6424 4.93453C14.8133 5.10553 14.8987 5.30835 14.8987 5.54297C14.8987 5.7776 14.8133 5.98041 14.6424 6.15141L7.76566 13.0424C7.59466 13.2133 7.39422 13.2987 7.16435 13.2987C6.93447 13.2987 6.73404 13.2133 6.56304 13.0424L3.34704 9.82641C3.17616 9.65541 3.0931 9.4526 3.09785 9.21797C3.1026 8.98335 3.19041 8.78054 3.36129 8.60954C3.53229 8.43866 3.7351 8.35322 3.96972 8.35322C4.20435 8.35322 4.40716 8.43866 4.57816 8.60954L7.16435 11.2102Z",
              fill: "#EBE9FF"
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
          "filter",
          {
            id: "filter0_d_3277_8971",
            x: "0",
            y: "0",
            width: "18.5",
            height: "19",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ jsx(
                "feFlood",
                {
                  floodOpacity: "0",
                  result: "BackgroundImageFix"
                }
              ),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ jsx(
                "feOffset",
                {
                  dx: "0.5",
                  dy: "1"
                }
              ),
              /* @__PURE__ */ jsx(
                "feComposite",
                {
                  in2: "hardAlpha",
                  operator: "out"
                }
              ),
              /* @__PURE__ */ jsx(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_3277_8971"
                }
              ),
              /* @__PURE__ */ jsx(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_3277_8971",
                  result: "shape"
                }
              )
            ]
          }
        ) })
      ]
    }
  );
};
export {
  IconCheck as default
};
